import { render, staticRenderFns } from "./centerOrderTable.vue?vue&type=template&id=6e7d8798&scoped=true&"
import script from "./centerOrderTable.vue?vue&type=script&lang=js&"
export * from "./centerOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./centerOrderTable.vue?vue&type=style&index=0&id=6e7d8798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7d8798",
  null
  
)

export default component.exports